import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { NavigationStepWrapperComponent } from './navigation-step-wrapper/navigation-step-wrapper.component';
import { NavigationStepComponent } from './navigation-step/navigation-step.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { SectionSeparatorComponent } from './section-separator/section-separator.component';


@NgModule({
  declarations: [
    SectionSeparatorComponent,
    SectionHeaderComponent,
    NavigationStepWrapperComponent,
    NavigationStepComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
  ],
  exports: [
    SectionSeparatorComponent,
    SectionHeaderComponent,
    NavigationStepWrapperComponent,
    NavigationStepComponent,
  ],
})
export class FormNavigationModule { }